import { AxisBottom as VisxAxisBottom } from '@visx/axis';
import { tickLabelProps } from './styles';
import { useTranslation } from 'react-i18next';
import {
  STUNDEN_MAX,
  MARGIN,
} from '@/domain/dienstplan/features/VisualEditor/constants';
import { useVisualEditorContext } from '@/domain/dienstplan/features/VisualEditor/VisualEditorContext';

const createTickLabels = (offset: number) => {
  const labels: Record<number, string> = {};
  for (let i = 0; i <= 24; i++) {
    const hour = (i + offset) % 24;
    labels[i] = hour.toString().padStart(2, '0');
  }
  return labels;
};

export function AxisBottom({ offset }: { offset: number }) {
  const { t } = useTranslation();
  const bottomTickValues = Array.from({ length: STUNDEN_MAX + 1 }, (_, i) => i);

  const { yMax, xScaleAxis } = useVisualEditorContext();
  const tickLabels = createTickLabels(offset);

  return (
    <VisxAxisBottom
      hideTicks
      top={MARGIN.top + yMax}
      left={MARGIN.left}
      scale={xScaleAxis}
      tickValues={bottomTickValues}
      tickFormat={(i) => {
        const idx = i.toString();
        return tickLabels[idx];
      }}
      orientation="bottom"
      tickLabelProps={tickLabelProps}
      stroke="#E5E5EA"
      label={t('domain.dienstplan.mindestbelegung.visualEditor.labels.uhrzeit')}
      labelProps={{
        fontSize: 15,
        fontWeight: 600,
      }}
    />
  );
}
